import { render, staticRenderFns } from "./departamental.vue?vue&type=template&id=3c916ace&scoped=true"
import script from "./departamental.vue?vue&type=script&lang=js"
export * from "./departamental.vue?vue&type=script&lang=js"
import style0 from "./departamental.vue?vue&type=style&index=0&id=3c916ace&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c916ace",
  null
  
)

export default component.exports